import React, { Component } from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';

import {AppSettings} from '../../constants';
import {Modal} from 'react-bootstrap';
import {FileUpload} from 'components/FileUpload/FileUpload';
import {PlacesWithStandaloneSearchBox} from 'components/geo-complete/CustomMap';
import { connect } from 'react-redux';
import Radio from 'components/CustomRadio/CustomRadio';

let location = {
  fullLocation: 'fullLocation',
  city: 'city',
  state: 'state',
  postalCode: 'postalCode'
};

class SetUpBuilderModal extends Component {
  static propTypes = {
    show: PropTypes.bool,
    toggleModal: PropTypes.func,
    title: PropTypes.string,
    history: PropTypes.object,
    builderAction: PropTypes.object,
    SetUpBuilderUser: PropTypes.object
  }

  constructor(props) {
    super(props);
    this.state = {
      fullLocation: '',
      city: '',
      state: '',
      postalCode: '',
      radio: '1',
      uploadedData: {},
      errors: {
        file: null
      }
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.SetUpBuilderUser.setupSuccess !== null &&
      nextProps.SetUpBuilderUser.setupSuccess === 'Done') {
      this.closeModal();
      window.location.reload();
    }
  }

  closeModal = () => {
    this.props.toggleModal({ modalName: '', ActiveModal: null });
  }

  onSubmit(e) {
    e.preventDefault();
    // this.submit.setAttribute('disabled', 'true');

    if (this.upload.state.files.length > 0) {
      this.upload.upload();
    } else {
      const {city, fullLocation, state, postalCode, radio} = this.state;
      if (fullLocation && !state) {
        this.setState({
          error: 'Invalid location. Please pick a location from the list.'
        });
      } else {
        this.setState({
          error: null
        });
        this.props.builderAction.builderSetupData({
          logoDiskPath: '',
          logoUrl: '',
          city: city,
          stateName: state,
          zipCode: postalCode,
          streetAddress: fullLocation,
          regionAndMarket: radio
        });
      }
    }
  }

  onChangeMap = (mapState) => {
    location.fullLocation = mapState.fullLocation;
    location.city = mapState.city;
    location.state = mapState.state;
    location.postalCode = mapState.postalCode;
    this.setState({...location});
  }

  handleRadio = event => {
    const target = event.target;
    this.setState({
      [target.name]: target.value
    });
  };

  onUpload = (data) => {
    this.setState({uploadedData: JSON.parse(data.xhr.responseText)}, () => {
      const {uploadedData, city, fullLocation, state, postalCode, radio} = this.state;
      if (fullLocation && !state) {
        this.setState({
          error: 'Invalid location. Please pick a location from the list.'
        });
      } else {
        this.setState({
          error: null
        });
        this.props.builderAction.builderSetupData({
          ...uploadedData,
          city: city,
          stateName: state,
          zipCode: postalCode,
          streetAddress: fullLocation,
          regionAndMarket: radio
        });
      }
    });
  }

  onChangeFileUpload = (data) => {
    if (!isEmpty(data.errors)) {
      this.setState({ errors: { file: data.errors}});
    } else {
      this.setState({ errors: { file: null}});
    }
  }

  onRemoveFile = () => {
    this.setState({ errors: { file: null}});
  }

  render() {
    const uploadLogoUrl = `${AppSettings.CURRENT_SITE_URI}/api/tenant/upload-logo`;
    const headers = [{'Authorization': `Bearer ${localStorage[AppSettings.S1_TOKEN]}`}];
    return (
      <div className=''>
        <Modal
          show={this.props.show}
          onHide={this.closeModal}
          dialogClassName='custom-modal'
          backdrop='static'
          keyboard={false}
          container={this}
          id='rename-modal'
        >
          <Modal.Header>
            <Modal.Title id='contained-modal-title-lg'>{this.props.title}</Modal.Title>
            <button
              className='close '
              onClick={() => {
                this.closeModal();
              }}
            >
              <i className='icon-icn_close' />
            </button>
          </Modal.Header>
          <Modal.Body>
            <div className='form-group'>
              <label>Company logo</label>
              <div className='box-image-upload'>
                {/*{!this.state.uploadedData.logoUrl &&*/}
                <FileUpload
                  name='files'
                  accept='image/png,image/jpeg'
                  maxFileSize={2098000}
                  url={uploadLogoUrl}
                  headers={headers}
                  className='image-upload'
                  onSelect={this.onChangeFileUpload}
                  onRemoveFile={this.onRemoveFile}
                  onUpload={this.onUpload}
                  chooseLabel='Select file'
                  showIcon={false}
                  multiFiles={false}
                  ref={ref => {this.upload = ref;}}
                />
                {/*}}*/}
                {/*{this.state.uploadedData.logoUrl &&
                  <div className='image'>
                    <img className='img-responsive margin-bottom-10' src={this.state.uploadedData.logoUrl} />
                    <button className='btn' onClick={() => {this.setState({uploadedData: {}});}}>Remove</button>
                  </div>
                }*/}
                {/*{!this.state.uploadedData.logoUrl && <p className='info'>Best size is 368x64 pixels. Only use PNG or JPG file. Limit the file size to 2MB.</p>}*/}
                <p className='info'>Best size is 368x64 pixels. Only use PNG or JPG file. Limit the file size to 2MB.</p>
                {this.state.errors.file && <span className='cls-danger help-block'>{this.state.errors.file}</span>}
              </div>

            </div>

            <div className='form-horizontal'>
              <div className='form-group'>
                <label className='col-md-3'>Company location</label>
                <div className='col-md-9'>
                  <PlacesWithStandaloneSearchBox className='search-box' ref={c => { this.location = c; }} onChange={this.onChangeMap} />
                  {this.state.error &&
                    <span className='text-danger'>{this.state.error}</span>}
                </div>
              </div>
            </div>

            <div className='form-group'>
              <label>Region and Market visibility</label>
              <Radio
                number='0dr'
                option='0'
                name='radio'
                className='site-one-radio'
                onChange={this.handleRadio}
                checked={this.state.radio === '0'}
                label='None'
              />
              <Radio
                number='1dr'
                option='1'
                name='radio'
                onChange={this.handleRadio}
                checked={this.state.radio === '1'}
                label='Region'
              />
              <Radio
                number='2dr'
                option='2'
                name='radio'
                onChange={this.handleRadio}
                checked={this.state.radio === '2'}
                label='Region and Market'
              />
            </div>
          </Modal.Body>

          <Modal.Footer >
            <button ref={ref => {this.submit = ref;}} disabled={this.state.errors.file ? true : false} className='btn btn-primary btn-siteone' onClick={this.onSubmit.bind(this)}>DONE</button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    SetUpBuilderUser: state.BuilderStore.SetUpBuilderUser
  };
};

export default connect(mapStateToProps)(SetUpBuilderModal);



// WEBPACK FOOTER //
// ./src/Builders/Components/SetupBuilderModal.js